import {createStrokeSVG} from './TEMPLATE'

// tabler: circle-check
export const CircleCheck_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', 'M9 12l2 2l4 -4'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
